import { ZODIAC_SIGNS, CHINESE_ZODIAC } from '../constants/options';

export const parseIdCard = (idCard) => {
  if (!idCard || idCard.length !== 18) return null;
  try {
    const genderCode = parseInt(idCard.charAt(16));
    const gender = genderCode % 2 === 1 ? '男' : '女';
    const year = idCard.substring(6, 10);
    const month = idCard.substring(10, 12);
    const day = idCard.substring(12, 14);
    const birthDate = `${year}-${month}-${day}`;
    const age = new Date().getFullYear() - parseInt(year);
    const zodiacSign = getZodiacSign(parseInt(month), parseInt(day));
    const chineseZodiac = getChineseZodiac(parseInt(year));
    return { gender, birthDate, age, zodiacSign, chineseZodiac };
  } catch (e) {
    return null;
  }
};

export const getZodiacSign = (month, day) => {
  const signs = [
    { sign: '摩羯座', end: [1, 19] }, { sign: '水瓶座', end: [2, 18] },
    { sign: '双鱼座', end: [3, 20] }, { sign: '白羊座', end: [4, 19] },
    { sign: '金牛座', end: [5, 20] }, { sign: '双子座', end: [6, 21] },
    { sign: '巨蟹座', end: [7, 22] }, { sign: '狮子座', end: [8, 22] },
    { sign: '处女座', end: [9, 22] }, { sign: '天秤座', end: [10, 23] },
    { sign: '天蝎座', end: [11, 22] }, { sign: '射手座', end: [12, 21] },
    { sign: '摩羯座', end: [12, 31] }
  ];
  for (const s of signs) {
    if (month < s.end[0] || (month === s.end[0] && day <= s.end[1])) return s.sign;
  }
  return '摩羯座';
};

export const getChineseZodiac = (year) => {
  const idx = (year - 4) % 12;
  return CHINESE_ZODIAC[idx >= 0 ? idx : idx + 12];
};

export const normalizeChineseZodiac = (value) => {
  if (!value) return '';
  if (value.startsWith('属')) return value.substring(1);
  return value;
};